import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { SITE } from "../../data/site";

/**
 * Desktop-only floating call button, fixed to the bottom-right corner.
 * Intentionally sized and placed to sit on top of (and cover) the
 * Emergent badge that the hosting layer injects there. z-index beats
 * the badge's 9999. Mobile already has its own sticky call bar.
 */
export const FloatingCallButton = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 160);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={SITE.phoneHref}
      data-testid="desktop-floating-call"
      aria-label={`Call ${SITE.phoneDisplay}`}
      className={`hidden lg:inline-flex items-center gap-3 bg-[#C05746] hover:bg-[#A64B3C] text-[#F9F7F4] pl-5 pr-6 py-3 font-semibold text-sm uppercase tracking-[0.14em] shadow-[0_10px_30px_rgba(0,0,0,0.2)] transition-all duration-300 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      style={{
        position: "fixed",
        bottom: "16px",
        right: "16px",
        zIndex: 10000,
        borderRadius: "50px",
        minWidth: "210px",
        minHeight: "48px",
      }}
    >
      <span className="w-8 h-8 rounded-full bg-[#F9F7F4]/15 flex items-center justify-center">
        <Phone size={15} strokeWidth={2.5} />
      </span>
      <span className="font-display text-base tracking-tight normal-case">
        {SITE.phoneDisplay}
      </span>
    </a>
  );
};
